/* eslint-disable react/forbid-prop-types,object-curly-newline */
import React from 'react';
import { Grid, Box, Typography } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const styles = (theme) => ({
  root: {
    width: '100%',
    marginBottom: theme.spacing(2),
    marginTop: 20,
  },
  titleContainer: {
    backgroundColor: theme.palette.primary.main,
    borderTopLeftRadius: 13,
    borderTopRightRadius: 13,
  },
  gridContainer: {
    padding: 10,
  },
  gridContainerContent: {
    padding: 0,
  },
  title: {
    color: theme.palette.white,
    fontFamily: '"BMI Poppins", "BMI Montserrat", Arial, sans-serif',
    paddingLeft: 10,
  },
  subTitle: {
    padding: 10,
    color: theme.palette.black,
  },
});

const CustomPanelWithoutPadding = ({ title = '', withoutTitle = false, subtitle = '', classes, children, border = true }) => (
  <div className={classes.root}>
    {(withoutTitle && subtitle) && (
    <Typography variant="h5" className={classes.subTitle}>{subtitle}</Typography>
    )}
    <Box
      display="flex"
      border={border ? 1 : 0}
      borderColor={border ? 'primary.main' : 'transparent'}
      bgcolor="background.paper"
      borderRadius="15px"
    >
      <Grid container item xs={12} direction="column">
        {!withoutTitle && (
        <Grid
          container
          direction="row"
          className={clsx(classes.titleContainer, classes.gridContainer)}
        >
          <Typography variant="h4" className={classes.title}>{title}</Typography>
        </Grid>
        )}
        <Grid container direction="column" className={classes.gridContainerContent}>
          {children}
        </Grid>
      </Grid>
    </Box>
  </div>
);

CustomPanelWithoutPadding.propTypes = {
  title: PropTypes.string,
  withoutTitle: PropTypes.bool,
  subtitle: PropTypes.string,
  classes: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  border: PropTypes.bool,
};

export default withStyles(styles)(CustomPanelWithoutPadding);
